export default __webpack_public_path__ + "static/media/peer-to-peer-chat.c0b49823.png";